// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"485":"Landing Page","726":"Archives","760":"QueryManagement"}[chunkId] + "." + {"485":"3fdfd0fe","726":"6d9b0b23","760":"7426bcc0"}[chunkId] + ".css";
};